import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Shield, Users, FileText, Book } from 'lucide-react';
import { useAuth } from '../../context/auth';

const Sidebar = ({ isOpen }) => {
  const location = useLocation();
  const { user } = useAuth();

  // Define admin users by email
  const adminEmails = [
    'vyo@s360digital.com',
    'admin@s360digital.com'
  ];

  // Check if current user is an admin
  const isAdmin = user && adminEmails.includes(user.email);

  const isPathActive = (path) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div 
      className={`h-full bg-white border-r border-gray-200 transition-all duration-300 ${
        isOpen ? 'w-64' : 'w-0'
      } overflow-y-auto`}
    >
      <nav className="py-4">
        <div className="space-y-1">
          <Link 
            to="/dashboard" 
            className={`
              flex items-center
              py-3
              px-6
              text-gray-700
              transition-all
              duration-200
              border-l-4
              ${location.pathname === '/dashboard' 
                ? 'border-blue-600 bg-blue-50 text-blue-600' 
                : 'border-transparent hover:bg-gray-50 hover:border-gray-300'}
            `}
          >
            <LayoutDashboard size={18} className="mr-3" />
            Dashboard
          </Link>
          
          <Link 
            to="/dashboard/access-management" 
            className={`
              flex items-center
              py-3
              px-6
              text-gray-700
              transition-all
              duration-200
              border-l-4
              ${isPathActive('/dashboard/access-management')
                ? 'border-blue-600 bg-blue-50 text-blue-600'
                : 'border-transparent hover:bg-gray-50 hover:border-gray-300'}
            `}
          >
            <Users size={18} className="mr-3" />
            Access Management
          </Link>

          <Link 
            to="/dashboard/request-access" 
            className={`
              flex items-center
              py-3
              px-6
              text-gray-700
              transition-all
              duration-200
              border-l-4
              ${isPathActive('/dashboard/request-access')
                ? 'border-blue-600 bg-blue-50 text-blue-600'
                : 'border-transparent hover:bg-gray-50 hover:border-gray-300'}
            `}
          >
            <FileText size={18} className="mr-3" />
            Request Access
          </Link>

          <Link 
            to="/dashboard/documentation" 
            className={`
              flex items-center
              py-3
              px-6
              text-gray-700
              transition-all
              duration-200
              border-l-4
              ${isPathActive('/dashboard/documentation')
                ? 'border-blue-600 bg-blue-50 text-blue-600'
                : 'border-transparent hover:bg-gray-50 hover:border-gray-300'}
            `}
          >
            <Book size={18} className="mr-3" />
            Documentation
          </Link>

          {/* <Link 
            to="/dashboard/meta" 
            className={`
              flex items-center
              py-3
              px-6
              text-gray-700
              transition-all
              duration-200
              border-l-4
              ${isPathActive('/dashboard/meta')
                ? 'border-blue-600 bg-blue-50 text-blue-600'
                : 'border-transparent hover:bg-gray-50 hover:border-gray-300'}
            `}
          >
            {/* <Facebook size={18} className="mr-3" />
            Meta Access
          </Link>

          <Link 
            to="/dashboard/gcp" 
            className={`
              flex items-center
              py-3
              px-6
              text-gray-700
              transition-all
              duration-200
              border-l-4
              ${isPathActive('/dashboard/gcp')
                ? 'border-blue-600 bg-blue-50 text-blue-600'
                : 'border-transparent hover:bg-gray-50 hover:border-gray-300'}
            `}
          >
            {/* <Cloud size={18} className="mr-3" /> 
            GCP Access
          </Link> */}

          {/* Admin Panel link only for admin users */}
          {isAdmin && (
            <Link 
              to="/dashboard/admin" 
              className={`
                flex items-center
                py-3
                px-6
                text-gray-700
                transition-all
                duration-200
                border-l-4
                ${isPathActive('/dashboard/admin')
                  ? 'border-blue-600 bg-blue-50 text-blue-600'
                  : 'border-transparent hover:bg-gray-50 hover:border-gray-300'}
              `}
            >
              <Shield size={18} className="mr-3" />
              Admin Panel
            </Link>
          )}

          {/* Admin Panel link only for admin users */}
          {/* {isAdmin && (
            <Link 
              to="/dashboard/debug" 
              className={`
                flex items-center
                py-3
                px-6
                text-gray-700
                transition-all
                duration-200
                border-l-4
                ${isPathActive('/dashboard/debug')
                  ? 'border-blue-600 bg-blue-50 text-blue-600'
                  : 'border-transparent hover:bg-gray-50 hover:border-gray-300'}
              `}
            >
              <WrenchIcon size={18} className="mr-3" />
              Debug Settings
            </Link>
          )} */}

        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
